export default "__VITE_ASSET__CHUYqByD__"